import { Box, Typography, IconButton, Card, CardContent } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const TemplateSuccess = ({ onBack }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          position: "absolute",
          top: 20,
          left: 20,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
       
        />
        {/* <Typography variant="body1">Sent to All People</Typography> */}
        <IconButton onClick={onBack} sx={{ ml: "auto" }}>
          <ArrowBackIcon />
        </IconButton>
      </Box>

      {/* Success Message */}
      <Card sx={{ p: 3, borderRadius: 2, boxShadow: 2, maxWidth: 400 }}>
        <CardContent>
          <Box
            component="img"
            src="https://cdn-icons-png.flaticon.com/512/1040/1040230.png"
            alt="Success Icon"
            sx={{ width: 50, mb: 2 }}
          />
          <Typography variant="h6" fontWeight="bold">
            Templates Sent Successfully!
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1}>
            Your templates have been delivered successfully. You can now proceed
            with your next action or review the sent messages.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TemplateSuccess;
